import CheckboxWidget from './CheckboxWidget'
import EmailWidget from './EmailWidget'
import PhoneWidget from './PhoneWidget'
import RadioWidget from './RadioWidget'
import SelectWidget from './SelectWidget'
import TextWidget from './TextWidget'

export default {
  CheckboxWidget,
  EmailWidget,
  PhoneWidget,
  RadioWidget,
  SelectWidget,
  TextWidget,
}
